import Vue from 'vue';

import jel from '@/services/api/jel/jel';
import i18n from '@/js/i18n';

export default class {
  // module: Sans aucun "/", nom du module vuex DOIT être égal au rootPath sous /jel
  // refreshMinProd : Délai raffraçichissement automatique (en minutes) en production
  // refreshMinDev :  Délai raffraçichissement automatique (en minutes) en développement
  //                  0=Aucun raffraîchissment automatique, qu'au chargement initial du SPA
  constructor({ module, refreshMinProd, refreshMinDev }) {
    const refreshMilliseconde =
      (process.env.NODE_ENV == 'production'
        ? refreshMinProd
        : Math.min(refreshMinProd, refreshMinDev)) *
      60 *
      1000;
    this.state = {
      module,
      rootPath: `/${module}`,
      // Délai de rafraîchissement automatique du REST endpoint
      refreshMilliseconde,
      isLoaded: false,
      liste: null,
    };
    this.getters = {
      /**
       * @param  {string} uuid
       * @return {object} Élément de la liste | null
       */
      getByUuid: (state) => (uuid) => {
        return state.liste ? state.liste.find((unElement) => unElement['@id'] == uuid) : null;
      },
      /**
       * @param  {string} name
       * @return {object} Élément de la liste | null
       */
      getByName: (state) => (name) => {
        return state.liste
          ? state.liste.find((unElement) => unElement.name === name || unElement['@name'] === name)
          : null;
      },
      /**
       * @param  {string} name qui sera name ou nameEn selon la locale
       * @return {object} Élément de la liste | null
       */
      getByNameI18n: (state) => (name) => {
        const champName = i18n.locale == 'en' ? 'nameEn' : '@name';
        return state.liste ? state.liste.find((unElement) => unElement[champName] === name) : null;
      },
      /**
       * @param  {string} uuid
       * @return {string} name ou nameEn selon la locale
       */
      getNameI18nByUuid: (state, getters) => (uuid) => {
        const champName = i18n.locale == 'en' ? 'nameEn' : '@name';
        return getters.getByUuid(uuid)?.[champName];
      },
      /**
       * @param  {string} name
       * @return {object} Élément de la liste | null
       */
      getUuidByName: (state, getters) => (name) => {
        return getters.getByName(name)?.['@id'];
      },
      /**
       * @param  {string} name
       * @return {object} Élément de la liste | null
       */
      getUuidByNameI18n: (state, getters) => (name) => {
        return getters.getByNameI18n(name)?.['@id'];
      },
    };
    this.actions = {
      refresh(context) {
        if (!context.rootState.idleVue.isIdle) {
          jel
            .getJelListeMAJ(context.state.module, context.state.liste)
            .then((listeMAJ) => {
              context.commit('UPDATE_LISTE', listeMAJ);
            })
            .catch((error) => console.log(error));
        }

        setTimeout(() => {
          context.dispatch('refresh');
        }, context.state.refreshMilliseconde);
      },
    };
    this.mutations = {
      // INTERNAL_INIT doit absolument être appelée de son parent
      async INTERNAL_INIT(state) {
        if (!state.isLoaded) {
          this.commit(`${state.module}/SET_LOADED`, true);
          const self = this;
          await jel
            .getJelListe(state.module)
            .then((liste) => {
              self.commit(`${state.module}/SET_LISTE`, liste);
            })
            .catch((error) => console.log(error));
          if (state.refreshMilliseconde > 0) {
            this.dispatch(`${state.module}/refresh`);
          }
        }
      },
      SET_LOADED(state, isLoaded) {
        state.isLoaded = isLoaded;
      },
      SET_LISTE(state, liste) {
        Vue.set(state, 'liste', liste);
      },
      UPDATE_LISTE(state, listeMAJ) {
        listeMAJ.forEach((itemMAJ) => {
          const foundIndex = state.liste.findIndex((item) => item['@id'] == itemMAJ['@id']);
          if (foundIndex == -1) {
            state.liste.push(itemMAJ);
          } else {
            Vue.set(state.liste, foundIndex, itemMAJ);
          }
        });
      },
    };
  }
}
